import { createAction } from 'typesafe-actions';
import { ACTIONS, IWinStatusState } from './types';

export const setWinStatusAction = createAction(ACTIONS.SET_WIN_STATUS)<IWinStatusState | null>();
